import * as jsxRuntime from "E:\\Projects\\CAE\\Credit Agricole Portal Revamp\\web\\app\\plugins\\calculator-module\\APIs\\src\\react\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment